module.exports = __webpack_public_path__ + "img/west-2-junior-high-school-director.62922a57.png";